module.exports = __webpack_public_path__ + "static/media/info-icon.11d3cf87.svg";